// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"fa5ffdbf","455":"ece98cc3","977":"172e7b34"}[chunkId] + ".chunk.js";
};